import { useFormikContext } from 'formik'

import { FormActions } from '../../../Form'
import {
  getIsViewingFormSubmittable,
  getViewingFormSubmitTextKey,
} from '../RentalPortalViewingFormModal.utils'

function RentalPortalViewingFormModalActions({ submitProps, ...restProps }) {
  const { values } = useFormikContext()

  return (
    <FormActions
      {...restProps}
      submitProps={{
        ...submitProps,
        disabled: !getIsViewingFormSubmittable(values),
        title: getViewingFormSubmitTextKey(values),
      }}
    />
  )
}

export default RentalPortalViewingFormModalActions
